import { sanitizeHtml, hasHtml } from "@/lib/sanitize";

/**
 * Renders back-office text that may contain light formatting
 * (bold, italic, links) added from the page editor.
 */
export const Rich = ({ value, as: Tag = "span", className, ...rest }) => {
  if (value === undefined || value === null || value === "") return null;
  if (!hasHtml(value)) {
    return (
      <Tag className={className} {...rest}>
        {value}
      </Tag>
    );
  }
  return (
    <Tag
      className={className}
      {...rest}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }}
    />
  );
};

export default Rich;
